import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { IMainTableColumn } from "components/MainTable/MainTableInterfaces";
import { IRCASettings } from "entities/RCA/RCASettingsEntity/RCASettingsEntityInterfaces";
import RCASettingsDurationTrigger from "./component/RCASettingsDurationTrigger";
import RCASettingsFrequencyTrigger from "./component/RCASettingsFrequencyTrigger";
import RCASettingsOwnerSelect from "./component/RCASettingsOwnerSelect";
import { translateDefaultEntity } from "utilities/localesUtilities";
import { DefaultTranslationFieldsInTable } from "constants/constants";

interface IRCASettingsColumns extends Omit<IMainTableColumn, "render"> {
    render: (row: IRCASettings) => string | JSX.Element | number;
}

const useRCASettingsColumns = (canEdit: boolean | undefined): IRCASettingsColumns[] => {
    const { t, i18n } = useTranslation();

    const columns = useMemo(
        (): IRCASettingsColumns[] => [
            {
                id: "downtimeType",
                label: t("rca.settings.downtime_type"),
                hideSortIcon: true,
                render: (row) =>
                    translateDefaultEntity(
                        i18n.language,
                        row.failure_type,
                        "name",
                        DefaultTranslationFieldsInTable.FAILURE_TYPE,
                    ),
            },
            {
                id: "durationTrigger",
                label: t("rca.settings.set_duration_trigger"),
                hideSortIcon: true,
                render: (row) => {
                    return <RCASettingsDurationTrigger canEdit={canEdit} row={row} />;
                },
            },
            {
                id: "or",
                label: "",
                hideSortIcon: true,
                render: () => t("rca.settings.or"),
                align: "center",
            },
            {
                id: "frequencyTrigger",
                label: t("rca.settings.set_frequency_trigger"),
                hideSortIcon: true,
                render: (row) => {
                    return <RCASettingsFrequencyTrigger canEdit={canEdit} row={row} />;
                },
            },
            {
                id: "owner",
                label: t("rca.settings.owner"),
                hideSortIcon: true,
                render: (row) => <RCASettingsOwnerSelect canEdit={canEdit} row={row} />,
            },
        ],
        [t, i18n.language, canEdit],
    );

    return columns;
};

export default useRCASettingsColumns;
